import { MarketsTableFields } from './enums'

export const marketTableHeaderTitles: Record<MarketsTableFields, string> = {
  [MarketsTableFields.title]: 'Name',
  [MarketsTableFields.description]: 'Description',
  [MarketsTableFields.createdAt]: 'Date created',
  // The actions column is icon-and-button only; a header would just add noise.
  [MarketsTableFields.actions]: '',
}

// Markets are a per-customer list of a handful of rows, so this stops at 100. The customers
// list carries 500/1000 only because of an explicit product request recorded alongside it.
export const marketPageSizeOptions = [25, 50, 100]

export const MARKETS_GRID_COLUMNS_STORAGE_KEY = 'admin.markets.gridColumns'
